import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function OrderRatings() {
  const history = useHistory();
  const sort = 5;
  const activePag = useRef(0);
  const [data, setData] = useState([]);
  const [ratings, setRatings] = useState([]);
  const [ratingsId, setRatingsId] = useState("");
  const [spinner, setSpinner] = useState(true);
  const [show, setShow] = useState(false);

  function getData(length) {
    axios
      .get(`${Baseurl.baseurl}/order/get-all-order-rating/${length}`)
      .then((res) => {
        console.log("result", res);
        setSpinner(false);
        if (res.data.status) {
          setRatings(
            (oldArray) => oldArray.concat(res.data.details.reverse()),
            () => {}
          );
          setData(document.querySelectorAll("#job_data tbody tr"));
        } else {
          swal("No More Data", "", "error", {
            button: "Done",
            timer: 1000,
          });
        }

        // if (res.data.status) {
        //   setRatings(res.data.details            );
        //   setData(document.querySelectorAll("#job_data tbody tr"));
        // }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
  };

  useEffect(() => {
    getData(ratings.length);
  }, []);

  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  function resolveRating() {
    axios
      .put(`${Baseurl.baseurl}/order/solve-order-rating/${ratingsId}`)
      .then((res) => {
        if (res.data.status) {
          swal("Resolved", res.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", res.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }

        setShow(false);
      })
      .catch((err) => {});
  }

  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
        }}
      >
        <Modal.Body>
          <h4>Are You sure !! you want to Resolve this Rating ?</h4>
        </Modal.Body>
        <Modal.Footer>
          <button
            onClick={() => {
              resolveRating();
            }}
            className="btn btn-primary"
          >
            Resolve
          </button>
        </Modal.Footer>
      </Modal>
      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-sm">
                <thead>
                  <tr>
                    <th>
                      <strong>Date</strong>
                    </th>
                    <th>
                      <strong>Rating </strong>
                    </th>
                    <th>
                      <strong>Reason</strong>
                    </th>
                    <th>
                      <strong>User</strong>
                    </th>
                    <th>
                      <strong>Center</strong>
                    </th>

                    <th>
                      <strong>Actions</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {ratings &&
                    ratings.map((rat, key) => (
                      <tr key={rat.id}>
                        <td>
                          {" "}
                          {rat.Date.Day}-{rat.Date.Month}-{rat.Date.Year}{" "}
                          {rat.Time.Hour}:{rat.Time.Minute}
                        </td>
                        <td>{rat.Rating}</td>
                        <td>{rat.Reason}</td>
                        <td>{rat.UserId?.Name}</td>
                        <td>{rat.OrderId?.CenterName}</td>

                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                  history.push(
                                    `/all-order-list/${rat.OrderId._id}/${
                                      activePag.current
                                    }/${Math.round(window.scrollY)}/ratingOrder`,
                                  );
                                }}
                              >
                                View Order
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setRatingsId(rat._id);
                                }}
                              >
                                Resolve
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!ratings && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero ratings
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
                <button
                  onClick={() => {
                    getData(ratings.length);
                  }}
                  className="btn btn-primary ml-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default OrderRatings;
